import React, { useState } from 'react';
import './Login.css';
import { Link, useHistory } from 'react-router-dom';
import { auth } from './firebase';

function Login() {
    const history = useHistory();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const login = (event) => {
        event.preventDefault(); // stop the refresh
        //do login logic here
        auth
        .signInWithEmailAndPassword(email, password)
        .then((auth) => {
            //logged in redirect to HoePage
            history.push("/");
        })
        .catch((e) => alert(e.message));
    }

    const register = (event) => {
        event.preventDefault(); // stop the refresh
        //do register logic here
        auth.createUserWithEmailAndPassword(email, password)
        .then((auth) => {
            //create an user and login then redirect to homepage
            history.push("/");
        })
        .catch((e) => alert(e.message));
    }

    return (
        <div className="login">
            <Link to="/">
            <img 
                className="login__logo"
                src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a9/Amazon_logo.svg/1024px-Amazon_logo.svg.png"
                alt=""
            />
            </Link>
            <div className="login__container">
                <h1>Sign-in</h1>
                <form>
                    <h5>E-mail</h5>
                    <input 
                        value={email} 
                        onChange={event => setEmail(event.target.value)}
                        type="email"
                    />
                    <h5>Password</h5>
                    <input 
                        value={password} 
                        type="password"
                        onChange={event => setPassword(event.target.value)}
                    />
                    <button 
                            className="login__signinButton" 
                            type="submit"
                            onClick={login}
                        >Sign In
                    </button>
                </form>
                <p>
                    By signing in, you agree that you have read and accepted our Conditions of Use and Privacy Notice.
                </p>
                <button 
                        className="login__registerButton"
                        type="submit"
                        onClick={register}
                    >Create your Amazon Account
                </button>
            </div>
        </div>
    )
}

export default Login
